import Vue from 'vue'
import GoogleAds from '../components/GoogleAds.vue'
import Ads from '../components/Ads.vue'
import customAds from '../components/customAds/ads.vue'
import nonImageAd from '../components/customAds/nonImageAds.vue'
Vue.component('GoogleAds',GoogleAds)
Vue.component('Ads',Ads)
Vue.component('customAds',customAds)
Vue.component('nonImageAd',nonImageAd)
